import { Spinner, Text } from '@apollo/orbit';
import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { launchesRouteConfig } from 'src/app/graph/routes';
import { format } from 'src/lib/format';
import { GraphQLTypes } from 'src/lib/graphqlTypes';

import { LaunchHistoryListItem } from './launchHistoryListItem/LaunchHistoryListItem';

interface Props {
  launches: Array<GraphQLTypes.LaunchHistoryListItemFragment>;
  selectedLaunchId: string;
  activeSchemaPublishId?: string;
  isCloudSupergraph: Boolean;
}

// TODO (launches): convert all these into links with the launch id as a query param.
// by default the page should land on most recent launch entry.
export const LaunchHistoryList = ({
  launches,
  selectedLaunchId,
  activeSchemaPublishId,
  isCloudSupergraph,
}: Props) => {
  const location = useLocation();

  return (
    <>
      <div className="flex h-12 items-center justify-between border-b border-primary bg-secondary p-6">
        <div className="flex items-center">
          <Spinner size="tiny" className="mr-2" />
          <Text variant="bodySb" size="sm" className="text-secondary">
            Checking for new launches...
          </Text>
        </div>
        <Text variant="bodySb" size="sm" className="text-secondary">
          Last {launches.length}{' '}
          {format.pluralize(launches.length, 'launch', 'es')}
        </Text>
      </div>
      {launches.map((launch, index) => {
        return (
          <Link
            to={launchesRouteConfig.locationFrom({
              location,
              patch: { launchId: launch.id },
            })}
            key={launch.id}
          >
            <LaunchHistoryListItem
              launch={launch}
              selected={launch.id === selectedLaunchId}
              activeSchemaPublishId={activeSchemaPublishId}
              isCloudSupergraph={isCloudSupergraph}
              isMostRecentLaunch={index === 0}
            />
          </Link>
        );
      })}
    </>
  );
};
